var map = {
	"./de/gotoTOPbg.png": "lfDG",
	"./en/gotoTOPbg.png": "/MVo",
	"./es/gotoTOPbg.png": "ylDu",
	"./fr/gotoTOPbg.png": "lUdc",
	"./ja/gotoTOPbg.png": "SDub",
	"./ko/gotoTOPbg.png": "OVZQ",
	"./pt/gotoTOPbg.png": "EJXy",
	"./ru/gotoTOPbg.png": "RGRd",
	"./tc/gotoTOPbg.png": "bzzp",
	"./th/gotoTOPbg.png": "aG/0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ewyb";